import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map, filter } from 'rxjs/operators';
import { LoginUserSuccess } from '@webapp/store/auth/action-creators';
import { LOGIN_USER_SUCCESS } from '@webapp/store/auth/actions';
import { getAuthAttributes } from '@webapp/utils/auth/get-auth-attributes';

export const trackSignInSuccess = (action$: Observable<LoginUserSuccess>) =>
  action$.pipe(
    ofType(LOGIN_USER_SUCCESS),
    filter((action) => !!action.user),
    map((action) => {
      const source = getAuthAttributes(action.user);

      if (window.analytics) {
        window.analytics.track('Signed In', {
          id: source?.sub,
          email: source?.email,
          phone: source?.telephone
        });
      }

      if (window.Intercom) {
        window.Intercom('boot', {  
          app_id: window.intercomSettings.app_id,  
          email: source?.email,
          name: [source?.given_name || '', source?.family_name || ''].join(' '),
          user_id: source?.sub
      });
      }
    }),
    filter(() => false)
  )